<script>
import { isNil, partition } from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  getAlocacoes,
  putAlocacao,
  deleteAlocacoes
} from "@/api/ativacaoped/business-plans/alocacoes.service";
import {
  listarParticipantesVinculados,
  vincularParticipantes,
  desvincularParticipante
} from "@/api/ativacaoped/business-plans/participantes.service";
import {
  postParticipante,
  putParticipante,
  postParticipanteCalibragem
} from "@/api/ativacaoped/participantes.service";
import FormModal from "@/components/form-modal.vue";
import Modal from "@/components/g-modal.vue";
import Field from "@/components/input-v.vue";
import MasterDetail from "@/components/master-detail.vue";
import { StatusBusinessPlanEnum } from "@/core/enums/ativacaoped";
import { toCurrency } from "@/helpers/toCurrency";
import AllocationTooltip from "../shared/allocation-tooltip.vue";
import ParticipantsAttatchModal from "../shared/participants-attatch-modal.vue";
import CreateParticipantModal from "../../../shared/create-participant-modal.vue";
import { TipoParticipante, TipoParticipanteLabel } from "../../../shared/participants";

export default {
  components: {
    AllocationTooltip,
    CreateParticipantModal,
    Field,
    FormModal,
    MasterDetail,
    Modal,
    ParticipantsAttatchModal
  },
  props: {
    editable: Boolean,
    endDate: String,
    hasAdminRole: Boolean,
    inWorkflowAdjustment: Boolean,
    nonPeople: Boolean,
    officialVersion: Boolean,
    participants: {
      type: Array,
      default: () => []
    },
    startDate: String,
    status: Number
  },
  data() {
    return {
      rows: [],
      selection: [],
      createModal: {
        opened: false,
        data: {}
      },
      tieModalOpened: false,
      calibrationModal: {
        data: {},
        opened: false
      },
      exportModal: {
        filename: "",
        opened: false
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    actionBarButtons() {
      const buttons = [
        {
          text: "Vincular participantes",
          icon: "mdi-link-variant-plus",
          hide: this.isExecutionPhase || !this.canManage,
          action: () => {
            this.tieModalOpened = true;
          }
        },
        {
          text: "Adicionar e vincular participante",
          icon: "mdi-account-plus-outline",
          hide: this.isExecutionPhase || !this.canManage,
          action: () => {
            this.createModal.data = {
              tipo_participante: 1
            };
            this.createModal.opened = true;
          }
        },
        {
          text: "Definir alocação (%)",
          icon: "mdi-chart-box-plus-outline",
          hide: !this.parsedParticipants.length || !this.canManage,
          action: () => {
            if (!this.startDate) {
              this.notify({
                message:
                  "Não é possível alocar horas sem definir a data inicial do projeto."
              });
              return;
            }

            if (!this.endDate) {
              this.notify({
                message:
                  "Não é possível alocar horas sem definir a data final do projeto."
              });
              return;
            }

            if (this.$refs.masterDetail) {
              const participantes = this.selection.map(({ id }) => id);
              this.$refs.masterDetail.selectedItem = { participantes };
              this.$refs.masterDetail.saveDialog = true;
            }
          }
        },
        {
          text: "Calibrar (%)",
          icon: "mdi-percent-box-outline",
          hide: !this.canCreate || !this.canManage,
          action: () => {
            this.calibrationModal.data = {};
            this.calibrationModal.opened = true;
          }
        },
        {
          text: "Ver timesheets",
          icon: "mdi-clock-outline",
          action: () => {
            const routeData = this.$router.resolve({
              name: "ativacaoped-timesheet",
              params: { id: this.businessPlanId }
            });

            window.open(routeData.href, "_blank");
          }
        },
        {
          text: "Importar alocações",
          icon: "mdi-upload-box-outline",
          align: "right",
          hide: this.isExecutionPhase || !this.canManage,
          action: () => {
            this.$refs.inputFileAlocacoes?.click();
          }
        },
        {
          text: "Exportar alocações",
          icon: "mdi-download-box-outline",
          align: "right",
          action: () => {
            this.exportModal.filename = this.defaultExportFilename();
            this.exportModal.opened = true;
          }
        }
      ];

      return buttons.filter(({ hide }) => !hide);
    },
    allMonths() {
      const projectStart = this.startDate
        ? moment(this.startDate, "YYYY-MM")
        : moment();
      const projectEnd = this.endDate
        ? moment(this.endDate, "YYYY-MM")
        : moment();
      const size = projectEnd.diff(projectStart, "months") + 1;
      return Array.from({ length: size }, (_, index) => {
        return moment(projectStart)
          .add(index, "months")
          .format("YYYY-MM");
      });
    },
    businessPlanId() {
      return this.$route.params.id;
    },
    calibrationCols() {
      return [
        {
          key: "participantes",
          name: "Participantes",
          type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
          rel: {
            to: "participantes",
            key: "id",
            name: "label"
          },
          placeholder: "Selecione os participantes",
          rules: [{ rule: "required" }]
        },
        {
          key: "percentual",
          name: "% calibragem",
          type: this.$fieldTypes.NUMBER,
          placeholder: "Ex: 10 ou -5",
          rules: [
            { rule: "required" },
            { rule: "max", params: { size: 100 } },
            { rule: "min", params: { size: -100 } }
          ]
        },
        {
          key: "justificativa",
          name: "Justificativa",
          type: this.$fieldTypes.TEXTAREA,
          counter: 500,
          placeholder: "Descreva o motivo da calibragem",
          rules: [{ rule: "required" }, { rule: "max", params: { size: 500 } }]
        }
      ];
    },
    fieldExport() {
      return {
        key: "filename",
        name: "Nome do arquivo",
        placeholder: "alocacao-consolidada.xlsx",
        type: this.$fieldTypes.TEXT,
        rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
      };
    },
    canCreate() {
      if (isNil(this.startDate)) {
        return false;
      }

      const startDate = moment(this.startDate, "YYYY-MM-DD");
      return moment().isSameOrAfter(startDate, "month");
    },
    canManage() {
      return (this.editable || this.hasAdminRole) && !this.isExecutionPhase;
    },
    cols() {
      const months = this.allMonths.map(key => ({
        key,
        name: moment(key, "YYYY-MM").format("MM/YYYY"),
        type: this.$fieldTypes.TEXT,
        hideInform: true,
        sortable: false,
        width: "150px",
        align: 0
      }));

      return [
        {
          key: "tipo_participante_label",
          name: "Categoria",
          type: this.$fieldTypes.TEXT,
          hideInform: true,
          width: "130px"
        },
        {
          key: "perfil",
          name: "Perfil",
          type: this.$fieldTypes.TEXT,
          hideInform: true,
          width: "170px"
        },
        {
          key: "budget_key",
          name: "Budget Key",
          type: this.$fieldTypes.TEXT,
          hideInform: true,
          width: "130px"
        },
        {
          key: "nome",
          name: "Participante",
          type: this.$fieldTypes.TEXT,
          hideInform: true,
          width: "200px"
        },
        {
          key: "participante_formacao",
          name: "Formacao",
          type: this.$fieldTypes.TEXT,
          hideInform: true,
          width: "150px"
        },
        {
          key: "calibragem",
          name: "% Calibragem",
          type: this.$fieldTypes.TEXT,
          hideInform: true,
          align: 1
        },
        {
          key: "justificativa",
          name: "Justificativa calibragem",
          type: this.$fieldTypes.TEXT,
          hideInform: true
        },
        ...months,
        {
          key: "participantes",
          name: "Participantes",
          type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
          rel: { to: "participants", key: "id", name: "label" },
          rules: [{ rule: "required" }],
          hideInTable: true,
          colSize: 12
        },
        {
          key: "competenciaIni",
          name: "Competência inicial",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          maxDate: this.endDate,
          minDate: this.startDate,
          hideInTable: true,
          colSize: 6
        },
        {
          key: "competenciaFim",
          name: "Competência final",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          maxDate: this.endDate,
          minDate: this.startDate,
          hideInTable: true,
          colSize: 6
        },
        {
          key: "percentual",
          name: "Percentual",
          type: this.$fieldTypes.NUMBER,
          rules: [{ rule: "required" }],
          hideInTable: true,
          colSize: 6
        }
      ];
    },
    contextOptions() {
      const options = [];

      if (this.canManage) {
        options.push(
          {
            name: "Editar",
            icon:
              "v-icon notranslate mdi theme--light mdi-pencil",
            cb: row => {
              this.createModal.data = this.getParticipantFormData(row);
              this.createModal.opened = true;
            }
          },
          {
            name: "Definir alocação (%)",
            icon:
              "v-icon notranslate mdi theme--light mdi-chart-box-plus-outline",
            cb: row => {
              if (this.$refs.masterDetail) {
                if (!this.selection.includes(row)) {
                  this.selection.push(row);
                }

                const participantes = this.selection.map(({ id }) => id);
                this.$refs.masterDetail.selectedItem = { participantes };
                this.$refs.masterDetail.saveDialog = true;
              }
            }
          },
          {
            name: `Excluir todas alocações${
              this.canDetachParticipant
                ? " e desvincular participante"
                : ""
            }`,
            icon: "v-icon notranslate mdi theme--light mdi-selection-remove",
            cb: async row => {
              if (!this.$refs.masterDetail) {
                return;
              }

              if (!this.selection.includes(row)) {
                this.selection.push(row);
              }

              // Snapshot dos participantes antes dos `await`: uma recarga pode
              // zerar `this.selection` no meio do fluxo e "perder" os dados.
              const participantes = this.selection.map(participante => ({
                id: participante.id,
                nome: participante.nome,
                projetadoIds: this.getValidProjetadoIds(participante)
              }));
              const temAlocacoesParaExcluir = participantes.some(
                ({ projetadoIds }) => projetadoIds.length > 0
              );

              if (!temAlocacoesParaExcluir && !this.canDetachParticipant) {
                this.$notify({
                  group: "geral",
                  duration: 5000,
                  type: "info",
                  title: "Nada a excluir",
                  text:
                    "Os participantes selecionados não possuem alocações para excluir."
                });
                return;
              }

              if (temAlocacoesParaExcluir) {
                const continueDeletion = await this.$refs.confirmDeleteModal.asyncOpen();

                if (!continueDeletion) {
                  return;
                }
              }

              // Exclusão das alocações por participante, disparadas em paralelo:
              // cada requisição é isolada, então a falha de um não cancela as demais.
              const deleteResults = await Promise.all(
                participantes
                  .filter(({ projetadoIds }) => projetadoIds.length > 0)
                  .map(async participante => {
                    try {
                      await this.customResource.batchDelete(participante.projetadoIds);
                      return { participante, status: "fulfilled" };
                    } catch (error) {
                      return { participante, status: "rejected", error };
                    }
                  })
              );
              const [comAlocacoesExcluidas, deleteErrors] = partition(
                deleteResults,
                ({ status }) => status === "fulfilled"
              );

              const comFalhaNaExclusao = deleteErrors.map(
                ({ participante }) => participante.id
              );
              const participantesParaDesvincular = participantes.filter(
                ({ id }) => !comFalhaNaExclusao.includes(id)
              );

              // Desvinculação por participante, também em paralelo: falha
              // individual não afeta os demais.
              let detachResults = [];

              if (
                this.canDetachParticipant &&
                participantesParaDesvincular.length
              ) {
                const continueDetach = await this.$refs.confirmDetachModal.asyncOpen();

                if (continueDetach) {
                  detachResults = await Promise.all(
                    participantesParaDesvincular.map(async participante => {
                      try {
                        await desvincularParticipante(
                          this.clientId,
                          this.businessPlanId,
                          participante.id
                        );
                        return { participante, status: "fulfilled" };
                      } catch (error) {
                        return { participante, status: "rejected", error };
                      }
                    })
                  );
                }
              }
              const [desvinculados, detachErrors] = partition(
                detachResults,
                ({ status }) => status === "fulfilled"
              );

              if (comAlocacoesExcluidas.length > 0) {
                this.$notify({
                  group: "geral",
                  duration: 5000,
                  type: "sucess",
                  title: "Alocações excluídas",
                  text: `Alocações excluídas de ${comAlocacoesExcluidas.length} participante(s).`
                });
              }

              if (desvinculados.length > 0) {
                this.$notify({
                  group: "geral",
                  duration: 5000,
                  type: "sucess",
                  title: "Participantes desvinculados",
                  text: `${desvinculados.length} participante(s) desvinculado(s) com sucesso.`
                });
              }

              const falhas = deleteErrors.concat(detachErrors);

              if (falhas.length) {
                const errorText = falhas
                  .map(
                    ({ error, participante }) =>
                      `${participante.nome}: ${this.errorHandler(error)}`
                  )
                  .join("\n");

                this.$notify({
                  group: "geral",
                  duration: 8000,
                  type: "error",
                  title: `Falha em ${falhas.length} participante(s)`,
                  text: errorText
                });
              }

              this.doReload();
              this.$emit("reload");
            }
          }
        );
      }

      if (this.canManage) {
        options.push({
          name: "Calibrar",
          icon:
            "v-icon notranslate mdi theme--light mdi-percent-box-outline",
          cb: row => {
            if (!this.selection.includes(row)) {
              this.selection.push(row);
            }

            this.calibrationModal.data = {
              participantes: this.selection.map(({ id }) => id)
            };
            this.calibrationModal.opened = true;
          }
        });
      }

      return options;
    },
    customResource() {
      const self = this;

      return {
        async get() {
          try {
            const response = await getAlocacoes(
              self.clientId,
              self.businessPlanId
            );
            self.rows = response.map(
              ({
                budget_key,
                calibragem,
                competencias,
                especialidade,
                formacao,
                matricula,
                participante_id,
                participante_nome,
                senioridade,
                tipo_participante_label
              }) => {
                const nome = matricula
                  ? `${matricula} - ${participante_nome}`
                  : participante_nome;
                const row = {
                  id: participante_id,
                  participante_nome: nome,
                  nome,
                  tipo_participante_label,
                  perfil:
                    senioridade && especialidade
                      ? `${senioridade} | ${especialidade}`
                      : senioridade || especialidade || "Sem perfil",
                  participante_formacao: formacao || "",
                  competenciaIds: [],
                  calibragem: calibragem
                    ? self.formatPercent(calibragem.percentual)
                    : "Indefinida",
                  justificativa:
                    calibragem && calibragem.justificativa
                      ? calibragem.justificativa
                      : "Indefinida",
                  budget_key: budget_key || "Sem BK"
                };

                self.allMonths.forEach(
                  key => (row[key] = { percentual: null, valor: null })
                );

                Object.entries(competencias).forEach(
                  ([competencia, { id, percentual, valor, custo_medio }]) => {
                    row[competencia] = {
                      percentual: percentual || null,
                      valor: valor || null,
                      custo_medio
                    };

                    if (id !== null && id !== undefined) {
                      row.competenciaIds.push(id);
                    }
                  }
                );

                return row;
              }
            );
          } catch (error) {
            self.notify(error);
            self.rows = [];
          }

          self.selection = [];
          return self.rows;
        },
        save(data) {
          const {
            participantes,
            competenciaIni: ini,
            competenciaFim: fim,
            ...rest
          } = data;
          const start = moment(ini, "YYYY-MM");
          const end = moment(fim, "YYYY-MM");
          const length = Math.abs(end.diff(start, "months")) + 1;
          const competencias = Array.from({ length }, (_, i) =>
            moment(start)
              .add(i, "months")
              .format("YYYY-MM")
          );
          const projetados = participantes.reduce((acc, participante_id) => {
            const items = competencias.map(competencia => ({
              ...rest,
              competencia,
              participante_id
            }));
            return [...acc, ...items];
          }, []);
          return putAlocacao(self.clientId, self.businessPlanId, projetados);
        },
        async batchDelete(ids) {
          if (!Array.isArray(ids)) {
            throw new Error(
              `Parametro ${ids} é invalido. Era esperado uma lista de ids de projetados.`
            );
          }

          const validIds = ids.filter(
            id =>
              id !== null &&
              id !== undefined &&
              id !== "" &&
              Number.isInteger(Number(id))
          );

          // Validação interna: sem ids válidos não há o que excluir, então a
          // chamada de API é evitada (o backend rejeita payload vazio/nulo).
          if (validIds.length === 0) {
            return;
          }

          await deleteAlocacoes(self.clientId, self.businessPlanId, validIds);
        }
      };
    },
    hasMultipleSelection() {
      return this.selection.length > 1;
    },
    hasNoneSelection() {
      return this.selection.length === 0;
    },
    canDetachParticipant() {
      return (
        this.isInitialPhase ||
        this.isVersioningMode ||
        this.inWorkflowAdjustment
      );
    },
    isExecutionPhase() {
      return (
        !this.isInitialPhase &&
        !this.isVersioningMode &&
        this.status !== StatusBusinessPlanEnum.REPROVADO
      );
    },
    isInitialPhase() {
      return [
        StatusBusinessPlanEnum.PREENCHIMENTO,
        StatusBusinessPlanEnum.APROVACAO
      ].includes(this.status);
    },
    isVersioningMode() {
      return [
        StatusBusinessPlanEnum.PREENCHIMENTO_NOVA_VERSAO,
        StatusBusinessPlanEnum.APROVACAO_NOVA_VERSAO
      ].includes(this.status);
    },
    parsedParticipants() {
      if (!Array.isArray(this.participants)) {
        return [];
      }

      return this.participants.map(({ budget_key, matricula, ...rest }) => ({
        ...rest,
        budget_key: budget_key?.posicao || "Sem BK",
        matricula: matricula ?? "Sem matrícula"
      }));
    },
    participantsNames() {
      if (this.hasNoneSelection) {
        return {
          names: [],
          last: ""
        };
      }

      const names = this.selection.map(({ nome }) => nome);
      const last = names.pop();

      return {
        names,
        last
      };
    },
    opts() {
      const participantes = this.parsedParticipants
        .filter(
          ({ tipo_participante }) =>
            tipo_participante == TipoParticipante.COLABORADOR
        )
        .map(({ budget_key, email, matricula, nome, perfil, ...rest }) => {
          let label = "";

          if (matricula || nome) {
            label += `${matricula || "Sem matricula"} - ${nome ||
              "Sem nome"}`;
          } else if (budget_key) {
            label += `${budget_key}`;
          } else if (perfil) {
            const { especialidade, senioridade } = perfil;
            label += `${senioridade ||
              "Sem senioridade"} - ${especialidade || "Sem especialidade"}`;
          }

          if (label && email) {
            label += ` (${email})`;
          }

          if (!label) {
            label = " -- ";
          }

          return {
            ...rest,
            label
          };
        })
        .sort(({ label: a }, { label: b }) => a.localeCompare(b));

      return {
        participants: this.parsedParticipants
          .map(({ budget_key, matricula, nome, ...rest }) => ({
            ...rest,
            budget_key,
            matricula,
            nome,
            label: `${matricula || "Sem matricula"} - ${nome ||
              budget_key ||
              "Sem nome"}`
          }))
          .sort(({ label: a }, { label: b }) => a.localeCompare(b)),
        participantes
      };
    }
  },
  methods: {
    async doCreateParticipant(data, closeFn) {
      try {
        const preparedData = this.prepareParticipantData(data);
        const response = data?.id
          ? await putParticipante(this.clientId, data.id, preparedData)
          : await postParticipante(this.clientId, preparedData);
        const type = data?.tipo_participante
          ? TipoParticipanteLabel[data?.tipo_participante]
          : "Participante";
        const perfilAtivo = (this.createModal.data.perfis || []).find(
          ({ id }) => id === data.perfil_id
        );
        const perfilLabel =
          perfilAtivo &&
          (perfilAtivo.senioridade || perfilAtivo.especialidade)
            ? perfilAtivo.senioridade && perfilAtivo.especialidade
              ? `${perfilAtivo.senioridade} | ${perfilAtivo.especialidade}`
              : perfilAtivo.senioridade || perfilAtivo.especialidade
            : null;
        const name = data.nome ?? perfilLabel ?? "Participante";
        const isEditing = !!data?.id;

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: isEditing
            ? `${type} alterado com sucesso`
            : `${type} cadastrado com sucesso`,
          text: isEditing
            ? `${name} foi atualizado na lista de participantes da empresa.`
            : `${name} foi adicionado a lista de participantes da empresa.`
        });
        this.selection = [];

        if (closeFn) {
          closeFn();
        }

        if (!isEditing) {
          await this.doTieParticipants([response.id]);
        } else {
          await this.reloadParticipants();
          this.doReload();
        }
      } catch (error) {
        this.notify(error);
      }
    },
    /**
     * Retorna apenas os ids de projetados (alocações) válidos da linha de um
     * participante. Participantes sem alocação recebem do backend um registro
     * sintético com `id` nulo — esse valor precisa ser ignorado para não chamar
     * o DELETE /projetado com `projetado_ids` inválidos.
     * @param {Object} row Linha de participante montada em `customResource.get`
     * @returns {number[]}
     */
    getValidProjetadoIds(row) {
      if (!row || !Array.isArray(row.competenciaIds)) {
        return [];
      }

      return row.competenciaIds.filter(
        id =>
          id !== null &&
          id !== undefined &&
          id !== "" &&
          Number.isInteger(Number(id))
      );
    },
    doReload() {
      this.$refs.masterDetail?.doLoad();
    },
    /**
     * Nome de arquivo sempre novo: BP + data/hora da exportação, para nunca
     * colidir com a validação de nome único do backend.
     * @returns {string}
     */
    defaultExportFilename() {
      const timestamp = moment().format("YYYY-MM-DD_HH-mm-ss");
      return `alocacao-consolidada-${this.businessPlanId}-${timestamp}.xlsx`;
    },
    async doExport() {
      try {
        const resource = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/exportacao`
        );
        const filename = this.exportModal.filename || this.defaultExportFilename();
        await resource.save({
          tipo: "alocacao-consolidado",
          arquivo_nome: this.sanitizeFilename(filename),
          filtros: {
            businessPlanId: this.businessPlanId
          }
        });

        this.$notify({
          group: "geral",
          duration: 10000,
          type: "info",
          title: `Exportação em processamento!`,
          text: `Quando concluída, você vai ser notificada pelo sistema.`
        });

        this.exportModal.opened = false;
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async onImportFileChange(event) {
      const [file] = Array.from(event.target.files);
      const MAX_FILE_SIZE = 10; // 10 MegaBytes

      if (!file) {
        return;
      }

      if (file.size > MAX_FILE_SIZE * 1024 * 1024) {
        this.notify({
          error: `O arquivo ${file.name} excedeu o limite de ${MAX_FILE_SIZE}MB e não foi importado.`
        });
        event.target.value = null;
        return;
      }

      try {
        this.$root.$emit("addLoadingProcess", "alocacaoconsolidadoimport");
        const api = this.api();
        const url = `/v1/ativacaoped/${this.clientId}/business-plans/importar`;
        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("tipo", "alocacao-consolidado");

        await api.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: "Importação concluída",
          text: `O arquivo está na fila para ser analisado e dentro de instantes você receberá uma notificação do sistema.`
        });
      } catch (error) {
        this.notify(error);
      } finally {
        this.$root.$emit("removeLoadingProcess", "alocacaoconsolidadoimport");
      }

      event.target.value = null; // Importante para poder voltar a anexar mais arquivos
    },
    sanitizeFilename(filename = "") {
      let safeName = filename
        .replace(/[\\\/:*?"<>|]/g, "") // Remove caracteres especiais
        .replace(/\s+/g, "-") // Remove espaços
        .replace(/[\.\s]+$/, "") // Remove pontos além do ponto da extensão
        .normalize("NFD") // Normaliza para separar o código dos acentos do código das letras
        .replace(/[\u0300-\u036f]/g, "") // Remove o código de todos os acentos
        .toLowerCase();

      if (!/\.xlsx$/i.test(safeName)) {
        safeName += ".xlsx";
      }

      return safeName;
    },
    async doTieParticipants(ids, close) {
      if (!ids?.length) {
        this.$notify({
          group: "geral",
          duration: 5000,
          type: "info",
          title: "Nenhum participante vinculado",
          text: `Tente novamente. Se o erro persisti, feche e abra a modal novamente.`
        });
        return;
      }

      try {
        await vincularParticipantes(
          this.clientId,
          this.businessPlanId,
          ids
        );

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: "Participantes vinculados",
          text: `${ids.length} participante(s) vinculado(s) com sucesso.`
        });

        await this.reloadParticipants();
        this.doReload();

        if (close) {
          close();
        }
      } catch (error) {
        this.notify(error);
      }
    },
    doUntieParticipant() {
      this.$refs.masterDetail?.deleteSelection();
    },
    async reloadParticipants() {
      try {
        const response = await listarParticipantesVinculados(
          this.clientId,
          this.businessPlanId
        );
        this.$emit("update:participants", response.data);
      } catch (error) {
        this.notify(error);
        this.$emit("update:participants", []);
      }
    },
    /** @method validate
     * @param {'approve' | 'save'} mode
     * @returns {boolean}
     */
    validate(mode = "save") {
      if (mode === "approve" && !this.rows?.length && !this.nonPeople) {
        this.$emit("error", 1);
        return false;
      }

      if (mode === "approve" && this.rows.length) {
        let valid = true;
        this.rows.map(row => {
          const competencias = Object.entries(row).filter(item =>
            item[0].includes("-")
          );
          const valores = competencias.map(item => {
            const percentual = item[1]?.percentual;

            if (percentual === null || percentual === undefined) {
              return 0;
            }

            const normalized =
              typeof percentual === "string"
                ? percentual.replace(",", ".").replace("%", "")
                : percentual;
            return Number.parseFloat(normalized);
          });
          const hasValidValue = valores.filter(value => value > 0);
          if (!hasValidValue.length) {
            this.$notify({
              title: `${hasValidValue.length} alocações estão válidas`,
              text: `O participante ${row.nome} possui alocações inválidas`,
              group: "geral",
              type: "error",
              duration: 7000
            });
            valid = false;
          }
        });

        if (!valid) {
          this.$emit("error", 1);
          return false;
        }
      }

      this.$emit("error", 0);
      return true;
    },
    getParticipantFormData(row) {
      const participant = this.participants.find(p => p.id === row.id);

      if (!participant) {
        return {};
      }

      return {
        id: participant.id,
        tipo_participante: participant.tipo_participante,
        funcionario_id: participant.funcionario_id,
        centro_custo_id: participant.centro_custo_id,
        perfil_id: participant.perfil?.id,
        budget_key_id: participant.budget_key?.id,
        matricula: participant.matricula,
        nome: participant.nome,
        papel_projeto: participant.papel_projeto,
        formacao: participant.formacao,
        email: participant.email,
        linkedin: participant.linkedin,
        perfis: participant.perfis,
        budget_keys: participant.budget_keys,
        centro_custos: participant.centro_custos
      };
    },
    prepareParticipantData(data) {
      const result = { ...data };

      delete result.especialidade;
      delete result.senioridade;
      delete result.competencia_inicio;

      return result;
    },
    async doCalibration(data, close) {
      try {
        const { participantes, percentual, justificativa } = data;

        if (!Array.isArray(participantes) || participantes.length === 0) {
          this.$notify({
            group: "geral",
            duration: 5000,
            type: "info",
            title: "Calibragem",
            text: "Selecione ao menos um participante."
          });
          return;
        }

        const getParticipanteNome = id => {
          const found = this.opts.participantes.find(p => p.id === id);
          return found ? found.label : `ID ${id}`;
        };

        const wrappedRequests = participantes.map(async participanteId => {
          try {
            await postParticipanteCalibragem(this.clientId, participanteId, {
              business_plan_id: this.businessPlanId,
              percentual,
              justificativa
            });
            return { participanteId, status: "fulfilled" };
          } catch (error) {
            return { participanteId, status: "rejected", error };
          }
        });

        const results = await Promise.all(wrappedRequests);
        const [sucess, errors] = partition(
          results,
          ({ status }) => status === "fulfilled"
        );

        if (sucess.length === 0) {
          this.$notify({
            group: "geral",
            duration: 5000,
            type: "error",
            title: "Calibragem",
            text: "Nenhum participante foi calibrado."
          });
          return;
        }

        if (errors.length > 0) {
          const errorNomes = errors
            .map(({ participanteId }) => getParticipanteNome(participanteId))
            .join(", ");
          this.$notify({
            group: "geral",
            duration: 5000,
            type: "warn",
            title: "Calibragem parcial",
            text: `Falha ao calibrar: ${errorNomes}.`
          });
          close();
          this.doReload();
          return;
        }

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: "Calibragem concluída",
          text: "Calibragem aplicada com sucesso!"
        });

        close();
        this.doReload();
      } catch (error) {
        this.notify(error);
      }
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === "") {
        return "0,00%";
      }

      const numeric = Number.parseFloat(
        typeof value === "string"
          ? value.replace(",", ".").replace("%", "")
          : value
      );

      if (Number.isNaN(numeric)) {
        return "0,00%";
      }

      return numeric
        .toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        .concat("%");
    },
    monthValue(item, month) {
      return item && item[month] && item[month].valor
        ? item[month].valor
        : 0;
    },
    monthCustoMedio(item, month) {
      return item && item[month] ? item[month].custo_medio : null;
    },
    custoMedioValue(item, month) {
      const custoMedio = this.monthCustoMedio(item, month);

      if (!custoMedio) {
        return 0;
      }

      const { valor } = custoMedio;
      return valor !== null && valor !== undefined ? valor : 0;
    },
    formatMonth(value) {
      if (value === null || value === undefined || value === "") {
        return "Indefinido";
      }

      const date = moment(value, "YYYY-MM", true);
      return date.isValid() ? date.format("MM/YYYY") : "Indefinido";
    },
    custoMedioPeriod(item, month, field) {
      const custoMedio = this.monthCustoMedio(item, month);

      if (!custoMedio) {
        return "Indefinido";
      }

      return this.formatMonth(custoMedio[field]);
    },
    tooltipText(item, month) {
      const competencia = item[month] || {};

      return [
        `Calibragem: ${item.calibragem}`,
        `Percentual: ${this.formatPercent(competencia.percentual)}`,
        `Valor: ${toCurrency(this.monthValue(item, month))}`,
        `Custo médio: ${toCurrency(this.custoMedioValue(item, month))}`,
        `Competência inicial: ${this.custoMedioPeriod(item, month, "competencia_inicio")}`,
        `Competência final: ${this.custoMedioPeriod(item, month, "competencia_fim")}`
      ].join("\n");
    },
    showMonthTooltip(event, item, month) {
      // Tooltip único da grade (ver allocation-tooltip.vue)
      this.$refs.allocationTooltip.show(
        event.currentTarget,
        this.tooltipText(item, month)
      );
    },
    hideMonthTooltip() {
      this.$refs.allocationTooltip.hide();
    }
  }
};
</script>

<template>
  <MasterDetail
    ref="masterDetail"
    :actionBarButtons="actionBarButtons"
    :canDelete="false"
    :canEdit="false"
    class="allocation-table"
    :class="{
      'no-context': !contextOptions.length,
      'with-selection': canManage
    }"
    :cols="cols"
    :contextOptions="contextOptions"
    :customResource="customResource"
    formTitle="Definir alocação (%)"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :hasFilter="false"
    :hasNewButton="false"
    height="auto"
    :opts="opts"
    :selection.sync="selection"
    :selectionCol="canManage"
  >
    <input
      ref="inputFileAlocacoes"
      accept=".xlsx"
      class="input-file"
      type="file"
      @change="onImportFileChange"
    />

    <Modal
      v-model="exportModal.opened"
      title="Exportar alocações"
      width="600"
    >
      <p>O processamento do arquivo é feito de forma assíncrona pelo Teros.</p>
      <p>
        Informe o nome do arquivo e aguarde a notificação de que o mesmo já
        está disponível para download.
      </p>

      <Field v-model="exportModal.filename" :label="fieldExport" />

      <template #buttons>
        <v-spacer />

        <v-btn
          class="px-5 ml-3"
          color="secondary"
          depressed
          @click="exportModal.opened = false"
        >
          Cancelar
        </v-btn>

        <v-btn
          class="px-5 ml-3"
          color="primary"
          dark
          depressed
          @click="doExport"
        >
          Exportar
        </v-btn>
      </template>
    </Modal>

    <template
      v-for="month in allMonths"
      v-slot:[`item.${month}`]="{ item }"
    >
      <div
        :key="`allocation-slot-${month}`"
        class="monthly-cell"
        @mouseenter="showMonthTooltip($event, item, month)"
        @mouseleave="hideMonthTooltip"
      >
        <span class="monthly-cell__allocation-percent">
          {{ item[month] ? formatPercent(item[month].percentual) : "0,00%" }}
        </span>
        <span class="monthly-cell__values">
          De {{ custoMedioValue(item, month) | toCurrency }}
        </span>
        <span class="monthly-cell__values">
          = {{ monthValue(item, month) | toCurrency }}
        </span>
      </div>
    </template>

    <AllocationTooltip ref="allocationTooltip" />

    <Modal ref="confirmDeleteModal" title="Confirmar exclusão">
      <p v-if="hasMultipleSelection">
        Deseja excluir todas as alocações para os participantes
        <span v-for="(name, key) in participantsNames.names" :key="key">
          <b> {{ name }} </b>,
        </span>
        e <b> {{ participantsNames.last }} </b>?
      </p>
      <p v-else-if="hasNoneSelection">
        Deseja excluir todas as alocações deste participante?
      </p>
      <p v-else>
        Deseja excluir todas as alocações para o participante
        <b> {{ participantsNames.last }} </b>?
      </p>

      <template #buttons="{ close }">
        <v-spacer />

        <v-btn
          class="px-5 ml-3"
          color="secondary"
          depressed
          @click="close(false)"
        >
          Cancelar
        </v-btn>

        <v-btn class="px-5 ml-3" color="error" depressed @click="close(true)">
          Excluir
        </v-btn>
      </template>
    </Modal>

    <Modal
      ref="confirmDetachModal"
      :title="`Desvincular participante${hasMultipleSelection ? 's' : ''}?`"
    >
      <p v-if="hasMultipleSelection">
        Deseja desvincular os participantes
        <span v-for="(name, key) in participantsNames.names" :key="key">
          <b> {{ name }} </b>,
        </span>
        e <b>{{ participantsNames.last }}</b> deste Business Plan?
      </p>
      <p v-else-if="hasNoneSelection">
        Deseja desvincular este participante deste Business Plan?
      </p>
      <p v-else>
        Deseja desvincular o participante
        <b>{{ participantsNames.last }}</b> deste Business Plan?
      </p>

      <template #buttons="{ close }">
        <v-spacer />

        <v-btn
          class="px-5 ml-3"
          color="secondary"
          depressed
          @click="close(false)"
        >
          Cancelar
        </v-btn>

        <v-btn class="px-5 ml-3" color="error" depressed @click="close(true)">
          Desvincular
        </v-btn>
      </template>
    </Modal>

    <CreateParticipantModal
      v-model="createModal.data"
      :opened.sync="createModal.opened"
      :title="createModal.data.id ? null : 'Adicionar e vincular participante'"
      @save="doCreateParticipant"
    />

    <ParticipantsAttatchModal
      :opened.sync="tieModalOpened"
      :participants="parsedParticipants"
      @save="doTieParticipants"
    />

    <FormModal
      :opened.sync="calibrationModal.opened"
      title="Calibrar Custo Médio"
      titleIcon="mdi-percent-box-outline"
      :cols="calibrationCols"
      :value.sync="calibrationModal.data"
      :opts="opts"
      :maxWidth="600"
      @save="doCalibration"
    ></FormModal>
  </MasterDetail>
</template>

<style lang="scss" scoped>
.input-file {
  display: none;
}

@mixin allocation-sticky-columns($widths...) {
  $left: 0px;

  @for $i from 1 through length($widths) {
    thead th,
    tbody tr:not(.v-data-table__empty-wrapper) td {
      &:nth-child(#{$i}) {
        background-color: inherit;
        position: sticky;
        left: $left;
        z-index: 1;
      }
    }

    thead th {
      &:nth-child(#{$i}) {
        z-index: 2;
      }
    }

    $left: $left + nth($widths, $i);
  }
}

.allocation-table {
  height: 100%;

  &.no-context {
    &::v-deep {
      tbody tr {
        cursor: auto !important;
      }
    }
  }

  &::v-deep .v-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    .v-card__text {
      flex-shrink: 0;
    }

    .v-data-table {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .v-data-table__wrapper {
      flex-grow: 1;
      overflow: auto;
      position: relative;

      tbody tr:not(.v-data-table__empty-wrapper) {
        background-color: #ffffff;
      }
    }

    .v-data-footer {
      flex-shrink: 0;
    }
  }

  &.with-selection {
    &::v-deep .v-data-table__wrapper {
      thead th,
      tbody tr:not(.v-data-table__empty-wrapper) td {
        &:first-child {
          width: 32px;
          min-width: 32px;
          max-width: 32px;
          padding-left: 4px;
          padding-right: 4px;
          text-align: center;
        }
      }

      @include allocation-sticky-columns(32px, 130px, 170px, 130px, 200px);
    }
  }

  &:not(.with-selection) {
    &::v-deep .v-data-table__wrapper {
      @include allocation-sticky-columns(130px, 170px, 130px, 200px);
    }
  }
}

.monthly-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;

  &__allocation-percent {
    white-space: nowrap;
  }

  &__values {
    color: rgba(0, 0, 0, 0.55);
    font-size: 11px;
    font-weight: 400;
    white-space: nowrap;
  }
}
</style>
